import Enumeration from '@enums/enum';

/**
 * Analytics events
 */
const AnalyticsEventsEnum = new Enumeration({
  DASHBOARD: 'Customer Console - Dashboard',
  ENQUIRY: 'Customer Console - Leaderboard',
  ENQUIRY_DETAILS: 'Customer Console - Enquiry Details',
  LOGIN: 'Login Loaded',
  PROVIDER: 'Provider Profile Loaded',
  MESSAGES: 'Messages Loaded',
  MESSAGE_SENT: 'Message Sent',
  AUTO_ACCEPT_DISABLED: 'Customer Console - Auto-Declare Disabled',
  DECISION_PERIOD_EXTENDED: 'Customer Console - Decision Period Extended',
  OFFER_EXPANDED: 'Customer Console - Offer Expanded',
  OFFER_ENQUIRED: 'Customer Console - Offer Declare Initiated',
  OFFER_ACCEPTED: 'Customer Console - Offer Declared',
  USER_LOGGED_IN: 'Customer Console - Logged In',
  RANKING_PREFERENCE_UPDATED: 'Customer Console - Ranking Preference Updated',
  USER_LOGGED_OUT: 'User Logged Out',
  USER_LOGIN_ERROR: 'User Login Error',
});


export default AnalyticsEventsEnum;
